/**
 * "Como conheceu o Oficina Ágil?" — resposta declarada pela própria pessoa
 * no cadastro. Complementa a origem rastreada (`lerOrigem`): o rastreio diz
 * de onde veio o clique; isto diz o que a pessoa lembra, e cobre o que o
 * rastreio não vê (indicação boca a boca, resposta de IA, desktop).
 *
 * Os valores são o contrato com o servidor (`POST /api/auth/signup`); os
 * rótulos são só de exibição. Quem montar a tela de cadastro usa
 * `OPCOES_COMO_CONHECEU` para o select e não precisa repetir a lista.
 */

export const VALORES_COMO_CONHECEU = [
  'google',
  'ia',
  'instagram',
  'facebook',
  'youtube',
  'tiktok',
  'indicacao',
  'whatsapp',
  'outro',
] as const;

export type ComoConheceu = (typeof VALORES_COMO_CONHECEU)[number];

/** Tamanho máximo do texto livre ("Qual?" / "Quem indicou?"). */
export const TAMANHO_MAXIMO_DETALHE_COMO_CONHECEU = 120;

const ROTULO_COMO_CONHECEU: Record<ComoConheceu, string> = {
  // Mesmos textos do cadastro do site (server/frontend/SignupModal).
  google: 'Pesquisa no Google',
  ia: 'ChatGPT, Gemini ou outra IA',
  instagram: 'Instagram',
  facebook: 'Facebook',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  indicacao: 'Indicação de alguém',
  whatsapp: 'Mensagem no WhatsApp',
  outro: 'Outro',
};

/** Opções do select, na ordem em que devem aparecer. */
export const OPCOES_COMO_CONHECEU: ReadonlyArray<{ valor: ComoConheceu; rotulo: string }> =
  VALORES_COMO_CONHECEU.map((valor) => ({ valor, rotulo: ROTULO_COMO_CONHECEU[valor] }));

const VALORES: ReadonlySet<string> = new Set(VALORES_COMO_CONHECEU);

/** Só um dos valores da lista; qualquer outra coisa é descartada. */
export function sanitizarComoConheceu(bruto: unknown): ComoConheceu | undefined {
  return typeof bruto === 'string' && VALORES.has(bruto) ? (bruto as ComoConheceu) : undefined;
}

/** Texto livre: trim, cortado em `TAMANHO_MAXIMO_DETALHE_COMO_CONHECEU`; vazio some. */
export function sanitizarComoConheceuDetalhe(bruto: unknown): string | undefined {
  if (typeof bruto !== 'string') return undefined;
  const limpo = bruto.trim().slice(0, TAMANHO_MAXIMO_DETALHE_COMO_CONHECEU).trim();
  return limpo || undefined;
}
